import React from 'react';
import { isSpotlightExclusive } from './SpotlightUtils';
import ExclusiveLabel from './ExclusiveLabel';

// A banner fills the width of the screen; its height follows the group size
// (the same ratios the image upload asks for: 75:8, 75:16 and 5:2)
const BANNER_RATIOS = {
  SMALL: '75 / 8',
  MEDIUM: '75 / 16',
  LARGE: '5 / 2',
};

const BannerItem = ({ tile, size, access, format }) => {
  const isExclusive = isSpotlightExclusive(access);
  // While editing, show the crop the admin just made
  const image =
    tile?.headingImage?.croppedBase64 ||
    tile?.headingImage?.croppedImage ||
    tile?.headingImage?.preview;
  return (
    <div
      className="spot-banner"
      style={{ aspectRatio: BANNER_RATIOS[size] || BANNER_RATIOS.LARGE }}
    >
      {image && <img className="spot-banner__image" src={image} alt="" />}
      <ExclusiveLabel visible={isExclusive} format={format} />
    </div>
  );
};

export default BannerItem;
